import * as React from "react";
import { GetSnapshotEventResponseItem } from "@/modules/snapshots/businessReports.types";

export interface SnapshotEventsContextValue {
  selectedSnapshotEventGroupIds: string[] | null;
  setSelectedSnapshotEventGroupIds: React.Dispatch<React.SetStateAction<string[] | null>>;
  selectedSnapshotEventGroups: Array<GetSnapshotEventResponseItem> | null;
  selectedEvent: GetSnapshotEventResponseItem | null;
  setSelectedEvent: React.Dispatch<React.SetStateAction<GetSnapshotEventResponseItem | null>>;
  selectedEventToEdit: GetSnapshotEventResponseItem | null;
  setSelectedEventToEdit: React.Dispatch<React.SetStateAction<GetSnapshotEventResponseItem | null>>;
  getCompletionRate: (event: GetSnapshotEventResponseItem) => number;
  sendReminderToRecipient: (recipientId: string) => Promise<void>;
  sendRemindersToAllRecipients: (eventId: string) => Promise<void>;
  makeSnapshotEventCompleted: (eventId: string) => void;
  makeSnapshotEventRecipientCompleted: (recipientId: string) => void;
}

export const SnapshotEventsContext = React.createContext<SnapshotEventsContextValue | null>(null);

export const useSnapshotEventsContext = () => {
  const context = React.useContext(SnapshotEventsContext);
  if (!context) {
    throw new Error("useSnapshotEventsContext must be used within a SnapshotEventsProvider");
  }
  return context;
};
